module.exports = __webpack_public_path__ + "img/message.2484beb3.svg";